import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { getV1LanguagesTranslations } from "../api-client/api.system-feature/api";
import { getToken } from "./common";

const loadedModules = new Set<string>();

function nestTranslation(flatObject: any) {
  const nested = {};
  const keys = Object.keys(flatObject);
  const namespaceKeys = new Set<string>();

  // Identify all keys that act as parent namespaces for nested objects
  keys.forEach((key) => {
    keys.forEach((otherKey) => {
      if (otherKey.startsWith(key + '.')) {
        namespaceKeys.add(key);
      }
    });
  });

  // Nest only the leaf keys to prevent intermediate primitive string collisions
  keys.forEach((key) => {
    if (!namespaceKeys.has(key)) {
      _.set(nested, key, flatObject[key]);
    }
  });

  return nested;
}

export async function loadModuleTranslations(moduleNames: string[], i18nInstance?: any) {
  const modulesToLoad = moduleNames?.filter(m => !loadedModules.has(m)) || [];

  if(!modulesToLoad.length) return;

  const filters = `(module.in=[${modulesToLoad?.join(',')}])`;

  const response = await getV1LanguagesTranslations({
    filters,
    limit: 9999,
    ...getToken(),
  });

  const data = response?.data?.translations || [];

  const resources: Record<string, Record<string, string>> = {};

  data.forEach((module: any) => {
    module?.fields?.forEach((item: any) => {
      for (const lang in item.translation) {
        if (!resources[lang]) {
          resources[lang] = {};
        }
        resources[lang][item.slug] = item.translation[lang];
      }
    })
  });

  
  if (i18nInstance) {
    Object.keys(resources).forEach((lang) => {
      const nested = nestTranslation(resources[lang]);
      i18nInstance.addResourceBundle(lang, 'translation', nested, true, true);
    });
  }

  modulesToLoad.forEach((module) => {
    loadedModules.add(module);
  });
}
